<template>
  <el-scrollbar class="w-full h-full">
    <div class="left">
      <!-- 轮播图 -->
      <carousel v-if="term !== 'saas' && term !== 'agent'" />

      <!-- 数据统计 -->
      <data-statistics />

      <!-- 审批管理 -->
      <approval-manage v-if="term !== 'agent'" />

      <!-- 代理商分润 -->
      <!-- <agent-profit v-if="term === 'agent'" /> -->
    </div>
    <div class="right">
      <!-- 用户信息 -->
      <user-info />

      <!-- 我的钱包 -->
      <my-wallet v-if="term !== 'saas'" />

      <!-- 快捷入口 -->
      <quick-entrance />

      <!-- 消息中心 -->
      <message-manage />
    </div>

    <slot />
  </el-scrollbar>
</template>

<script setup lang="ts">
import Carousel from './components/Carousel.vue';
import DataStatistics from './components/DataStatistics.vue';
import ApprovalManage from './components/ApprovalManage.vue';
import UserInfo from './components/UserInfo.vue';
import MyWallet from './components/MyWallet.vue';
import QuickEntrance from './components/QuickEntrance.vue';
import MessageManage from './components/MessageManage.vue';
// import AgentProfit from './components/AgentProfit.vue';
import { PropType, provide } from 'vue';

defineOptions({ name: 'HomePage' });

const props = defineProps({
  term: {
    type: String as PropType<'company' | 'server' | 'agent' | 'saas'>,
    required: true,
  },
});

provide('term', props.term);
</script>

<style lang="scss" scoped>
:deep(.el-scrollbar__view) {
  @apply flex gap-x-[12px];

  .left {
    @apply flex-1 w-[40%] flex flex-col gap-y-[12px];
  }

  .right {
    @apply w-[376px] min-w-[376px] flex flex-col gap-y-[12px];
  }
}
</style>
